import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ApiPaths, api } from "@/lib/api";
import type { OrgInvitePreview } from "@/lib/types";
import { AcceptInviteFlow, InvitePreview } from "@/modules/invites";
import { Spinner } from "@/components/Spinner";

export default function InvitePage() {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const q = useQuery({
    queryKey: ["invite-preview", token],
    queryFn: async () => {
      if (!token) throw new Error("missing token");
      const res = await api.get<OrgInvitePreview>(ApiPaths.invitePreview(token));
      return res.data;
    },
    enabled: !!token,
    retry: false,
  });

  return (
    <main className="min-h-dvh bg-nb-bg py-10">
      {q.isLoading && <Spinner fullscreen label={t("ui.invitePage.loading")} />}
      {q.isError && (
        <div className="card mx-auto mt-12 max-w-md">
          <h1 className="text-xl font-semibold">{t("ui.invitePage.notFoundTitle")}</h1>
          <p className="mt-2 text-sm text-nb-text">
            {t("ui.invitePage.notFoundBody")}
          </p>
        </div>
      )}
      {q.data && token && (
        <InvitePreview preview={q.data}>
          <AcceptInviteFlow token={token} preview={q.data} />
        </InvitePreview>
      )}
    </main>
  );
}